module.exports = __webpack_public_path__ + "static/media/srirachahotsauce.3ea62f55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/flavor/srirachahotsauce.jpg
// module id = 149
// module chunks = 0